import React from "react";
import { CN_NOTIFY_EVENT_TYPE } from "@/services/print/client/cainiaoPrintAgentClient";
import { DY_NOTIFY_EVENT_TYPE } from "@/services/print/client/jinritemaiPrintAgentClient";
import { PDD_NOTIFY_EVENT_TYPE } from "@/services/print/client/pddPrintAgentClient";
import { KWAI_NOTIFY_EVENT_TYPE } from "@/services/print/client/kwaiPrintAgentClient";
import { db } from "@/services/db";
import { PrintBatch, PrintBatchTask, PrintResult, PrintResultStatus } from "@/services/db/tables";
import {
    NotifyPrintResultResponseData,
    TaskStatus as CN_TaskStatus,
} from "@/services/print/client/types/cainiao/api/notifyPrintResult";
import { JinritemaiNotifyPrintResultResponse } from "@/services/print/client/types/jinritemai/api/JinritemaiNotifyPrintResult";
import {
    PrintResultNotifyResponseData,
    TaskStatus as PDD_TaskStatus,
} from "@/services/print/client/types/pdd/api/printResultNotify";
import { PrintableOrder } from "@/services/print/waybill/impl/AbstractEwaybillPrinter";
import { toJS } from "mobx";
import { notification } from "antd";
import moment from "moment";
import DY_TaskStatusEnum from "@/services/print/client/types/jinritemai/enum/TaskStatusEnum";
import { KWaiNotifyPrintResultResponse } from "@/services/print/client/types/KWai/api/KWaiNotifyPrintResult";
import {
    NotifyPrintResultResponseData as XHS_NotifyPrintResultResponseData,
    TaskStatus as XHS_TaskStatus,
} from "@/services/print/client/types/XiaoHongShu/api/notifyPrintResult";
import { XHS_NOTIFY_EVENT_TYPE } from "@/services/print/client/XiaoHongShuPrintAgentClient";
import { CHANEL_SHOP_NOTIFY_EVENT_TYPE } from "@/services/print/client/ChannelShopPrintAgentClient";
import { ChannelShopPrintResponseData } from "@/services/print/client/types/ChannelShop/ChannelShopResponseData";
import AiKuCunPrintAgentClient, { AIKUCUN_NOTIFY_EVENT_TYPE } from "@/services/print/client/AiKuCunPrintAgentClient";
import { AiKuCunPrintResponseData } from "@/services/print/client/types/AiKuCun/AiKuCunResponseData";
import { NEXT_XHS_NOTIFY_EVENT_TYPE } from "@/services/print/client/NextXiaoHongShuPrintAgentClient";
import {
    NotifyPrintResultResponseData as NEXT_XHS_NotifyPrintResultResponseData,
    TaskStatus as NEXT_XHS_TaskStatus,
} from "@/services/print/client/types/NextXiaoHongShu/api/notifyPrintResult";

const PROCESS_PRINT_NOTIFICATION_KEY = "PROCESS_PRINT_NOTIFICATION_KEY";
const SUCCESS_PRINT_NOTIFICATION_KEY = "SUCCESS_PRINT_NOTIFICATION_KEY";
const FAIL_PRINT_NOTIFICATION_KEY = "FAIL_PRINT_NOTIFICATION_KEY";

let instance: WaybillPrinterResultStore;

let currentPrintBatchIds: number[] = [];

/**
 * 快递单打印机结果响应store
 */
class WaybillPrinterResultStore {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;

        this.init();

        return instance;
    }

    init() {
        window.addEventListener(CN_NOTIFY_EVENT_TYPE, this.cnNotifyCallback);
        window.addEventListener(DY_NOTIFY_EVENT_TYPE, this.dyNotifyCallback);
        window.addEventListener(PDD_NOTIFY_EVENT_TYPE, this.pddNotifyCallback);
        window.addEventListener(KWAI_NOTIFY_EVENT_TYPE, this.ksNotifyCallback);
        window.addEventListener(XHS_NOTIFY_EVENT_TYPE, this.xhsNotifyCallback);
        window.addEventListener(NEXT_XHS_NOTIFY_EVENT_TYPE, this.nextXhsNotifyCallback);
        window.addEventListener(CHANEL_SHOP_NOTIFY_EVENT_TYPE, this.chanelShopNotifyCallback);
        window.addEventListener(AIKUCUN_NOTIFY_EVENT_TYPE, this.aiKuCunNotifyCallback);

        // window.addEventListener("beforeunload", this.beforeunload);
        // window.addEventListener("unload", this.unload);
    }

    // beforeunload = (e: BeforeUnloadEvent) => {
    //     if (currentPrintBatchIds.length) {
    //         var confirmationMessage = "离开此网站，将无法检测打印组件消息，不能及时提醒打印出纸失败等异常情况";

    //         e.returnValue = confirmationMessage;

    //         return confirmationMessage;
    //     }
    // };

    // 页面关闭的时候记录当前页面未打印完的批次
    // unload = () => {
    //     localStorage.setItem("_PRINTER_BATCH_RESULT_", JSON.stringify(currentPrintBatchIds));
    // };

    async addPrintBatch(params: Omit<PrintBatch, "created" | "timesPrintingInDay">) {
        const { shippingAddress, template, copies, printerName, count } = params;

        const nowMoment = moment();
        const created = nowMoment.valueOf();

        const todayStartValue = nowMoment.startOf("days").valueOf();
        const todayEndValue = nowMoment.endOf("days").valueOf();

        const isDbOpen = db.isOpen();

        if (!isDbOpen) {
            return null;
        }

        const todayAllPrintBatches = await db.printBatches
            .filter((it) => {
                if (it.created >= todayStartValue && it.created <= todayEndValue) {
                    return true;
                }

                return false;
            })
            .toArray();

        const timesPrintingInDay = todayAllPrintBatches.length + 1;

        const printBatch: PrintBatch = {
            count,
            shippingAddress: toJS(shippingAddress),
            template: toJS(template),
            copies,
            created,
            printerName,
            timesPrintingInDay,
        };

        const toSaveBatch = JSON.parse(JSON.stringify(printBatch));

        const printBatchId = await db.printBatches.add(toSaveBatch);

        currentPrintBatchIds.push(printBatchId);

        return printBatchId;
    }

    addPrintBatchTask = async (params: PrintBatchTask) => {
        const { batchId, printTaskId, ewaybillCount } = params;

        return db.printBatchTasks.add({
            batchId,
            printTaskId,
            ewaybillCount,
        });
    };

    addPrintResult = async (batchId: number, printTaskId: string, printableOrders: PrintableOrder[]) => {
        const printResults: PrintResult[] = printableOrders.map((printableOrder) => {
            const result: PrintResult = {
                batchId: batchId,
                waybillNo: printableOrder?.waybillNo,
                status: PrintResultStatus.PROCESSING,
                message: "处理中",
                printTaskId: printTaskId,
            };

            return result;
        });

        await db.printResults.bulkAdd(printResults);
    };

    dispose = () => {
        window.removeEventListener(CN_NOTIFY_EVENT_TYPE, this.cnNotifyCallback);
        window.removeEventListener(DY_NOTIFY_EVENT_TYPE, this.dyNotifyCallback);
        window.removeEventListener(PDD_NOTIFY_EVENT_TYPE, this.pddNotifyCallback);
        window.removeEventListener(KWAI_NOTIFY_EVENT_TYPE, this.ksNotifyCallback);
        window.removeEventListener(XHS_NOTIFY_EVENT_TYPE, this.xhsNotifyCallback);
        window.removeEventListener(NEXT_XHS_NOTIFY_EVENT_TYPE, this.nextXhsNotifyCallback);
        window.removeEventListener(CHANEL_SHOP_NOTIFY_EVENT_TYPE, this.chanelShopNotifyCallback);
        window.removeEventListener(AIKUCUN_NOTIFY_EVENT_TYPE, this.aiKuCunNotifyCallback);

        // window.removeEventListener("beforeunload", this.beforeunload);
        // window.removeEventListener("unload", this.unload);
    };

    /**
     * 外部调用 如果打印超时,以及其他情况,则直接将批次内的任务都置为失败
     */
    async setPrintBatchError(batchId: number) {
        if (batchId) {
            const results = await db.printResults.where("batchId").equals(batchId).toArray();

            results.map((it) => {
                if (it.status === PrintResultStatus.PROCESSING) {
                    it.status = PrintResultStatus.FAIL;
                }

                return it;
            });

            await db.printResults.bulkPut(results);

            await this.checkPrintPatchDone(batchId);
        }
    }

    /**
     * 检查该打印任务的打印批次是否全部打印完成
     * @param taskId 发送到打印机任务内的任务id
     */
    checkPrintPatchDoneByChildPrintTaskId = async (printTaskId: string) => {
        const printTask = await db.printBatchTasks.where("printTaskId").equals(printTaskId).first();

        if (!printTask) {
            return;
        }
    };

    checkPrintPatchDone = async (batchId: number) => {
        const printBatch = await db.printBatches.where("id").equals(batchId).first();

        if (!printBatch) {
            return;
        }

        const printTasks = await db.printBatchTasks.where("batchId").equals(batchId).toArray();

        const printTaskIds = printTasks.map((it) => it.printTaskId);

        const allPrintResults = await db.printResults.where("printTaskId").anyOfIgnoreCase(printTaskIds).toArray();

        if (!allPrintResults?.length) {
            return;
        }

        const hasProcessResult = allPrintResults.find((it) => it.status === PrintResultStatus.PROCESSING);

        // 如果还在处理中的任务 跳过处理
        // 没有处理中的 则说明任务都完成 或者 有部分任务失败了
        if (hasProcessResult) {
            return;
        }

        const hasFail = allPrintResults.find((it) => it.status === PrintResultStatus.FAIL);
        const printMoment = moment(printBatch.created);

        const days = printMoment.date();

        const title = `【${days}-${printBatch.timesPrintingInDay.toString().padStart(3, "0")}-${printBatch.count}单】`;
        const time = <p className="mt10">打印时间：{printMoment.format("YYYY-MM-DD HH:mm:ss")}</p>;

        // 说明有失败的订单 弹框提示
        if (hasFail) {
            notification.error({
                title: <span style={{ marginLeft: -10 }}>{title}有打印失败的单号</span>,
                description: (
                    <div>
                        <span>
                            {days}日第{printBatch.timesPrintingInDay}次打印的{printBatch.count}
                            个单号，检测到有快递单打印出纸失败
                            <a
                                className="ml10"
                                target="_blank"
                                href="https://qw15p3s8hv.feishu.cn/wiki/wikcnEd7bb9mUkFT7RAxxWZc5Kh"
                            >
                                查看处理建议
                            </a>
                        </span>
                        {time}
                    </div>
                ),
                key: FAIL_PRINT_NOTIFICATION_KEY,
                duration: 0,
                placement: "bottomRight",
            });
            return;
        }

        // 则任务都成功了
        // notification.success({
        //     message: `${title}打印结束`,
        //     description: (
        //         <div>
        //             <span>
        //                 {days}日第{printBatch.timesPrintingInDay}次打印的{printBatch.count}
        //                 个单号已全部打印完成，请检查快递单数量和信息是否正确
        //             </span>
        //             {time}
        //         </div>
        //     ),
        //     key: SUCCESS_PRINT_NOTIFICATION_KEY,
        // });
    };

    cnNotifyCallback = async (event: Event) => {
        const data = event?.["data"] as NotifyPrintResultResponseData;

        console.log("cn notify callback process success", data);

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        switch (data?.taskStatus) {
            case CN_TaskStatus.RENDERED:
                realMessage = "渲染完成";
                realStatus = PrintResultStatus.PROCESSING;
                break;
            case CN_TaskStatus.FAILED:
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case CN_TaskStatus.PRINTED:
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        if (data?.taskStatus === CN_TaskStatus.PRINTED || data?.taskStatus === CN_TaskStatus.FAILED) {
            this.checkPrintPatchDoneByChildPrintTaskId(taskId);
        }
    };

    /** 跟菜鸟是一样 */
    xhsNotifyCallback = async (event: Event) => {
        const data = event?.["data"] as XHS_NotifyPrintResultResponseData;

        console.log("xhs notify callback process success", data);

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        switch (data?.taskStatus) {
            case XHS_TaskStatus.RENDERED:
                realMessage = "渲染完成";
                realStatus = PrintResultStatus.PROCESSING;
                break;
            case XHS_TaskStatus.FAILED:
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case XHS_TaskStatus.PRINTED:
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        if (data?.taskStatus === XHS_TaskStatus.PRINTED || data?.taskStatus === XHS_TaskStatus.FAILED) {
            this.checkPrintPatchDoneByChildPrintTaskId(taskId);
        }
    };

    nextXhsNotifyCallback = async (event: Event) => {
        const data = event?.["data"] as NEXT_XHS_NotifyPrintResultResponseData;

        console.log("next-xhs notify callback process success", data);

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        switch (data?.taskStatus) {
            case NEXT_XHS_TaskStatus.RENDERED:
                realMessage = "渲染完成";
                realStatus = PrintResultStatus.PROCESSING;
                break;
            case NEXT_XHS_TaskStatus.FAILED:
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case NEXT_XHS_TaskStatus.PRINTED:
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        if (data?.taskStatus === NEXT_XHS_TaskStatus.PRINTED || data?.taskStatus === NEXT_XHS_TaskStatus.FAILED) {
            this.checkPrintPatchDoneByChildPrintTaskId(taskId);
        }
    };

    dyNotifyCallback = async (event: Event) => {
        const data = event["data"] as JinritemaiNotifyPrintResultResponse;
        console.log("dy notify callback", data);

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        switch (data?.taskStatus) {
            case DY_TaskStatusEnum.RENDER:
                realMessage = "渲染完成";
                realStatus = PrintResultStatus.PROCESSING;
                break;
            case DY_TaskStatusEnum.FAILED:
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case DY_TaskStatusEnum.PRINTED:
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        if (data?.taskStatus === DY_TaskStatusEnum.PRINTED || data?.taskStatus === DY_TaskStatusEnum.FAILED) {
            this.checkPrintPatchDoneByChildPrintTaskId(taskId);
        }
    };

    pddNotifyCallback = async (event: Event) => {
        const data = event["data"] as PrintResultNotifyResponseData;

        console.log("pdd notify callback", data);

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        switch (data?.taskStatus) {
            case PDD_TaskStatus.RENDERED:
                realMessage = "渲染完成";
                realStatus = PrintResultStatus.PROCESSING;
                break;
            case PDD_TaskStatus.FAILED:
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case PDD_TaskStatus.PRINTED:
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        if (data?.taskStatus === PDD_TaskStatus.PRINTED || data?.taskStatus === PDD_TaskStatus.FAILED) {
            this.checkPrintPatchDoneByChildPrintTaskId(taskId);
        }
    };

    ksNotifyCallback = async (event: Event) => {
        const data = event["data"] as KWaiNotifyPrintResultResponse;

        console.log("ks notify callback", data);

        const taskId = data?.taskID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        switch (data?.taskStatus) {
            case "partPrinted":
                realMessage = "部分打印完成";
                realStatus = PrintResultStatus.FAIL;
                break;
            case "failed":
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case "printed":
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        this.checkPrintPatchDoneByChildPrintTaskId(taskId);
    };

    chanelShopNotifyCallback = async (event: Event) => {
        const data = event["data"] as ChannelShopPrintResponseData;

        const taskId = data?.requestID;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;

        /** 微信小店是每个文档都返回是否成功,但是目前无法通过每个文档结果找到对应表中的数据
         *  文档结果中仅有taskId（对应菜鸟的documentId）,无运单号
         *  而printResults表仅存储taskId，无存储documentId
         */
        let taskStatus = "";

        if (!data?.results?.length) {
            taskStatus = "failed";
        } else {
            if (data?.results?.every(({ success }) => success)) {
                taskStatus = "printed";
            } else if (data?.results?.every(({ success }) => !success)) {
                taskStatus = "failed";
            } else {
                taskStatus = "partPrinted";
            }
        }

        switch (taskStatus) {
            case "partPrinted":
                realMessage = "部分打印完成";
                realStatus = PrintResultStatus.FAIL;
                break;
            case "failed":
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case "printed":
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        this.checkPrintPatchDoneByChildPrintTaskId(taskId);
    };

    async aiKuCunNotifyCallback(event) {
        const data = event["data"] as AiKuCunPrintResponseData;

        const taskId = data?.pushBackMessage.taskId;

        if (!taskId) {
            return;
        }

        let realMessage = "处理中";
        let realStatus: PrintResultStatus = PrintResultStatus.PROCESSING;
        let taskStatus = "";

        if (data?.code === AiKuCunPrintAgentClient.SUCCESS_CODE) {
            taskStatus = "printed";
        } else {
            taskStatus = "failed";
        }

        switch (taskStatus) {
            case "failed":
                realMessage = "打印失败";
                realStatus = PrintResultStatus.FAIL;
                break;
            case "printed":
                realMessage = "打印成功";
                realStatus = PrintResultStatus.SUCCESS;

                break;
            default:
                break;
        }

        await db.printResults
            .where({
                printTaskId: taskId,
            })
            .modify((result) => {
                result.status = realStatus;
                result.message = realMessage;
            });

        this.checkPrintPatchDoneByChildPrintTaskId(taskId);
    }
}

export default WaybillPrinterResultStore;
